import { Dispatch, SetStateAction } from 'react';
import { Box, Tooltip } from '@rossum/ui/material';
import {
  GridEditBooleanCell,
  GridEditInputCell,
  GridEditSingleSelectCell,
  GridRenderEditCellParams,
} from '@rossum/ui/x-data-grid-pro';
import { useHandleSelectionSync } from './useHandleSelectionSync';

type RenderEditCellExtraProps = {
  setBatchEditError: Dispatch<SetStateAction<boolean>>;
  Component:
    | typeof GridEditInputCell
    | typeof GridEditSingleSelectCell
    | typeof GridEditBooleanCell;
};

const EditInputCellWithValidation = ({
  errorMessage,
  setBatchEditError,
  Component,
  ...props
}: GridRenderEditCellParams & RenderEditCellExtraProps) => {
  const { field, error, api: apiRef } = props;
  const hasError = !!error;

  useHandleSelectionSync({
    apiRef,
    field,
    id: props.id,
    hasError,
    setBatchEditError,
  });

  return (
    <Tooltip
      open={hasError}
      title={errorMessage}
      arrow={false}
      sx={{
        display: 'flex',
        position: 'relative',
        top: '-1px',
        width: '100%',
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'error.main',
            color: 'error.contrastText',
          },
        },
      }}
    >
      <Box component="span">
        <Component {...props} />
      </Box>
    </Tooltip>
  );
};

export const renderEditCellWithValidation =
  ({ setBatchEditError, Component }: RenderEditCellExtraProps) =>
  (params: GridRenderEditCellParams) => (
    <EditInputCellWithValidation
      {...params}
      Component={Component}
      setBatchEditError={setBatchEditError}
    />
  );
